module.exports = __webpack_public_path__ + "img/SEM TUBETE -mobile.c5f1d020.png";